import React from "react";
import "./DetailsSection.css";
import { GoDotFill } from "react-icons/go";

const DetailsSection = ({ title, subtitle, items, end }) => {
    return (
        <div className="details-section">
            <h2 className="details-title">{title}</h2>

            <div className="details-card-content">
                {subtitle && (
                    <h3 className="details-card-title">{subtitle}</h3>
                )}
                <ul className="details-list">
                    {Array.isArray(items) && items.map((item, idx) => {
                        // Default icon fallback
                        const Icon = items?.icon || GoDotFill;
                        return (

                        <li key={idx} className="details-item">
                            <div className="details-icon">
                                {typeof Icon === "string" ? Icon : <Icon />}
                            </div>
                            <div className='details-item-text'>
                                {item?.title && (
                                    <div className="details-item-title">{item.title}</div>
                                )}
                                {item?.text && (
                                    <div className="details-item-description">{item.text}</div>
                                )}
                            </div>
                        </li>
                    )})}
                </ul>
            </div>
            {end && <p>{end}</p>}
        </div>
    );
};

export default DetailsSection;
